import { GET_MEMBER_BY_ID } from "@/utils/requestUrl";
import { getToken, getUserId } from "@/utils/sessionStoraggeUtil";
import { LOGOUT, SET_USER_INFO } from "./mutationsType";

export const actionSetUserInfo = async (context) => {
  const userId = getUserId();

  if (!userId) {
    context.commit(LOGOUT);
    return;
  }

  const headers = {
    "Content-Type": "application/json"
  };

  const token = getToken();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const baseUrl = (window._env_ && window._env_.VUE_APP_REQUEST_DOMAIN) || "";
  const response = await fetch(baseUrl + GET_MEMBER_BY_ID, {
    method: "POST",
    headers,
    body: JSON.stringify({ MemberId: userId })
  });

  let result = null;
  try {
    result = await response.json();
  } catch (error) {
    result = null;
  }

  if (!response.ok) {
    throw new Error((result && result.message) || "取得會員資訊失敗");
  }

  if (result && result.status === "failure") {
    throw new Error(result.message || "取得會員資訊失敗");
  }

  context.commit(SET_USER_INFO, (result && result.data) || {});
};

